import Vue from "vue";
import translate from "../translate";
const tr = {
  install(Vue, options) {
    Vue.prototype.$translate = translate;
  },
};

Vue.use(tr);
